import React from 'react'

import { PrototypeWarningModal } from '../../components/PrototypeWarningModal'

export function PrototypeWarningModalContainer(): JSX.Element | null {
  const hasData = localStorage.getItem('show-demo-popup') != null
  if (hasData) return null
  return <PrototypeWarningModal />
}
